module.exports = __webpack_public_path__ + "static/media/teacher_login_aehs.806b5fd1.jpg";